var styles = {"whiteBackground":"GoogleIcon-module_whiteBackground__ZijJa","svg":"GoogleIcon-module_svg__yOtXH"};

export { styles as default };
//# sourceMappingURL=GoogleIcon.module.scss.js.map
